export default __webpack_public_path__ + "static/media/scotiabank.f8c44164.jpg";